import { getFancyboxButtonShareTpl } from 'components/FancyboxButtons/FancyboxButtonShare';
import SharingPopup from 'components/SharingPopup/SharingPopup';

import { isElement } from './detectInlineType';

import { type DOMNode, type Element } from 'html-react-parser';
import { renderToString } from 'react-dom/server';

function findImgSrc(anchor: Element): string {
  for (const child of anchor.children as DOMNode[]) {
    if (!isElement(child)) continue;
    if (child.name === 'figure') {
      for (const grandchild of child.children as DOMNode[]) {
        if (isElement(grandchild) && grandchild.name === 'img') return grandchild.attribs?.src ?? '';
      }
    }
  }
  return '';
}

function resolveMediaUrl(href: string): string {
  try {
    const inner = new URL(href).searchParams.get('url');
    if (inner) return inner;
  } catch {
    // not a valid URL or no url param — use as-is
  }
  return href;
}

export function withShareAttribs(anchor: Element): Record<string, string> {
  const href = resolveMediaUrl(anchor.attribs?.href ?? '');
  const caption = anchor.attribs?.['data-caption'] ?? '';
  const imgSrc = findImgSrc(anchor);

  let opts: Record<string, unknown> = {};
  try {
    opts = JSON.parse(anchor.attribs?.['data-options'] ?? '{}') as Record<string, unknown>;
  } catch {
    // malformed data-options — start fresh
  }

  const buttons: string[] = (Array.isArray(opts.buttons) ? (opts.buttons as string[]) : ['close']).filter(
    (button) => button !== 'download',
  );
  if (!buttons.includes('share')) buttons.unshift('share');

  return {
    ...anchor.attribs,
    'data-options': JSON.stringify({
      ...opts,
      buttons,
      share: { tpl: renderToString(<SharingPopup url={href} title={caption} image={imgSrc} />) },
      btnTpl: { share: getFancyboxButtonShareTpl() },
    }),
  };
}
